// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__3z5DK","large":"Avatar_large__1iT_2","small":"Avatar_small__1O382","mini":"Avatar_mini__2V8il"};